import React from "react";
import Reveal from "./Reveal";

export const SectionHeading = ({ eyebrow, title, sub, align = "left", light = false }) => (
  <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <div className={`mb-4 font-mono text-xs font-semibold uppercase tracking-[0.25em] ${light ? "text-amber-soft" : "text-amber-brand"}`}>
        {eyebrow}
      </div>
    )}
    <h2 className={`font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl lg:text-5xl ${light ? "text-offwhite" : "text-forest-dark"}`}>
      {title}
    </h2>
    {sub && (
      <p className={`mt-4 font-body text-base leading-relaxed ${light ? "text-offwhite/70" : "text-espresso/70"}`}>
        {sub}
      </p>
    )}
  </Reveal>
);

export default SectionHeading;
